import ShopTile from './ShopTile';

export * from './ShopTile';
export default ShopTile;
